export default "__VITE_ASSET__70cebafa__"